import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AppointmentsPage from './AppointmentsPage';
import ReservationCalendarPage from './reserve/ReservationCalendarPage';
import AppointmentReschedule from './reschedule/AppointmentReschedule';
import ReserveNewAppointmentPage from './reserve/ReserveNewAppointmentPage';
import AppointmentFromQueue from './reserve/AppointmentFromQueue';

class AppointmentRouter extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/appointments" exact component={AppointmentsPage} />
        <Route
          exact
          path={'/appointments/new/'}
          component={ReserveNewAppointmentPage}
        />
        <Route
          exact
          path={'/appointments/new/:clinicId/:reasonId'}
          component={ReservationCalendarPage}
        />
        <Route
          path="/appointments/reschedule/:appointmentId"
          component={AppointmentReschedule}
        />
        <Route
          exact
          path="/appointments/fromQueue/:appointmentId"
          component={AppointmentFromQueue}
        />
      </Switch>
    );
  }
}

export default AppointmentRouter;
